import { render, staticRenderFns } from "./elevator_item_info_card.vue?vue&type=template&id=018fa46c&scoped=true&"
import script from "./elevator_item_info_card.vue?vue&type=script&lang=js&"
export * from "./elevator_item_info_card.vue?vue&type=script&lang=js&"
import style0 from "./elevator_item_info_card.vue?vue&type=style&index=0&id=018fa46c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018fa46c",
  null
  
)

export default component.exports